export class Unsub {

  constructor(
    public customerID: string,
    public submittedTime: string,
    public countryNumber: string,
    public browser: string,
    public email_nl?: boolean,
    public email_ms?: boolean,
    public email_is?: boolean,
    public post?: boolean,
    public phone?: boolean
  ) {}

}
